import { useFormik } from "formik";
import React, { forwardRef, useImperativeHandle } from "react";
import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { inAppNotificationForm_InAppNotificationFragment$key } from "@relay/inAppNotificationForm_InAppNotificationFragment.graphql";
import { IN_APP_NOTIFICATION_FRAGMENT } from "./in-app-notification-form.graphql";
import {
	InAppNotificationFormProps,
	InAppNotificationFormRef,
	InAppNotificationFormState,
} from "./in-app-notification-form.types";
import { DefaultTextFieldComponent } from "../../../../components/DefaultTextInput";
import { ValidatedField } from "../../../../components/ValidatedField";

export const InAppNotificationForm = forwardRef<
	InAppNotificationFormRef,
	InAppNotificationFormProps
>(function InAppNotificationForm({ messageDefinitionRef, onSubmit }, ref) {
	const { t } = useTranslation("common");
	const data = useFragment<inAppNotificationForm_InAppNotificationFragment$key>(
		IN_APP_NOTIFICATION_FRAGMENT,
		messageDefinitionRef ?? null,
	);
	const initialData = {
		title: data?.inAppNotification?.title ?? "",
		content: data?.inAppNotification?.content ?? "",
	};

	const formik = useFormik<InAppNotificationFormState>({
		initialValues: initialData,
		onSubmit: (values) => {
			onSubmit?.(values);
		},
	});

	useImperativeHandle(ref, () => ({
		submit: formik.submitForm,
		validate: () => formik.validateForm().then((errors) => !errors),
	}));

	return (
		<>
			<ValidatedField<InAppNotificationFormState, string>
				name={"title"}
				label={t("general.title")}
				component={DefaultTextFieldComponent}
				formikConfig={formik}
			/>
			<ValidatedField<InAppNotificationFormState, string>
				name={"content"}
				label={t("forms.content")}
				component={DefaultTextFieldComponent}
				formikConfig={formik}
			/>
		</>
	);
});
